import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
import { mapState } from 'vuex';
export default {
  name: 'WidgetChartToolboxEditor',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    activeToolboxActions: {
      get() {
        return this.getByKey('chartOptions.toolbox.actions', []);
      },
      set(val) {
        this.setByKey('chartOptions.toolbox.actions', val);
      }
    },
    toolboxActions() {
      const actions = ['dataZoom', 'dataView', 'saveAsImage'];
      return actions.map(a => ({
        text: this.$t(`Dashboards.components.widgetChartOptionsEditor.inputs.toolbox.actions.actions.${a}`),
        value: a
      }));
    }
  },
  watch: {
    'value.chartOptions.toolbox.actions': {
      handler(val) {
        if (!Array.isArray(val)) {
          this.setByKey('chartOptions.toolbox.actions', this.toolboxActions.map(a => a.value));
        }
      },
      immediate: true
    }
  },
  methods: {
    setByKey(key, val) {
      const clone = cloneDeep(this.value);
      set(clone, key, val);
      this.$emit('input', clone);
    },
    getByKey(key, defaultValue = undefined) {
      return get(this.value, key, defaultValue);
    }
  }
};